/**
 * @file StatementChecksDrawer.js
 * @version 1.0.1
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-10-20
 * @modified 2026-10-20
 *
 * The detail behind Generate Statements' check chips — review flags, the
 * sync with Xero, the Xero check, the Accounts confirmation, how fresh the
 * figures are — in one window, opened at the chip's section. These used to
 * be panels stacked above the statements on every step.
 * 1.0.1 (2026-10-20, the statements look): section titles sentence case
 * (sr-check-title).
 */

import React, { useEffect, useRef } from 'react';
import Modal from './Modal';

/**
 * @param {object} props
 * @param {string|null} props.focus - the section key to open at; null = closed
 * @param {Array<{ key: string, title: string, node: React.ReactNode }>} props.sections
 * @param {function} props.onClose
 */
function StatementChecksDrawer({ focus, sections, onClose }) {
  const bodyRef = useRef(null);
  useEffect(() => {
    if (!focus || !bodyRef.current) return;
    const el = bodyRef.current.querySelector(`[data-check-section="${focus}"]`);
    if (el && typeof el.scrollIntoView === 'function') el.scrollIntoView({ block: 'start' });
  }, [focus]);
  if (!focus) return null;
  return (
    <Modal isOpen={true} onClose={onClose} size="lg" className="statement-checks" title="Checks">
      <div className="sr-checks-body" ref={bodyRef}>
        {sections.filter(s => s.node).map(s => (
          <section key={s.key} data-check-section={s.key} className={`sr-check-section${s.key === focus ? ' focus' : ''}`}>
            <h4 className="sr-check-title">{s.title}</h4>
            {s.node}
          </section>
        ))}
      </div>
    </Modal>
  );
}

export default StatementChecksDrawer;
